import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import store from '../store'
Yup.addMethod(Yup.string, "valida_email", function (errorMessage) {
    return this.test(`valida_email`, errorMessage, function (email) {
        if (email && email.length > 0) {
            //var regex = /^[a-zA-ZñÑ0-9\+\.\_\%\-\+]{1,256}\@[a-zA-ZñÑ0-9][a-zA-ZñÑ0-9\-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9\-]{1,25})+$/;
            var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (regex.test(email)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
Yup.addMethod(Yup.string, "valida_rut_schvr", function (errorMessage) {
  return this.test(`valida_rut_schvr`, errorMessage, function (rut) {

    if (rut && rut.length > 0) {
      var regex = /^\d*$/;
      if (regex.test(rut)) {
        return true;
      } else {
        return false;
      }
    }
    return true;

    /*if (rut && rut.length > 0) {
      
      rut = rut && rut.split('.').join('');
      rut = rut && rut.split('-').join('');
  
      //Valor acumulado para el calculo de la formula
      var nAcumula = 0;
      //Factor por el cual se debe multiplicar el valor de la posicion
      var nFactor = 2;
      //Digito verificador
      var nDv = 0;
      var nDvReal;
      //extraemos el ultimo numero o letra que corresponde al verificador
      //La K corresponde a 10
      if (rut && rut.charAt(rut.length - 1).toUpperCase() == 'K' )
          nDvReal = 10;
      //el 0 corresponde a 11
      else if (rut && rut.charAt(rut.length - 1)== 0 )
          nDvReal = 11;
      else
          nDvReal =rut && rut.charAt(rut.length - 1);
      for (var nPos =rut &&  rut.length -2; nPos >=0; nPos--) {
          nAcumula +=rut &&  rut.charAt(nPos).valueOf() * nFactor;
          nFactor++;
          if (nFactor > 7) nFactor = 2;
      }
  
      nDv = 11-(nAcumula % 11)
      if (nDv == nDvReal) {
          return true;
      } else {
          return false;
      }
    }
    return true;*/
  })
})
Yup.addMethod(Yup.string, "valida_patente_rcg", function (errorMessage) {
    return this.test(`valida_patente_rcg`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})

let isFonoImplicado=false
const validationSchemas =(pais,paisImplicado)=> Yup.object({
    rutImplicado:Yup.string().test(
      "len",
      "Rut implicado no es válido.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schvr("Rut implicado no válido."),
    rutConductor:Yup.string().test(
      "len",
      "Rut conductor no es válido.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schvr("Rut conductor no válido."),
    rutPropietario:Yup.string().test(
      "len",
      "Rut propietario no es válido.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 12);
      }
    ).valida_rut_schvr("Rut propietario no válido."),
    emailImplicado:Yup.string().valida_email("Email implicado no válido"),
    emailConductor:Yup.string().valida_email("Email conductor no válido"),
    emailPropietario:Yup.string().valida_email("Email propietario no válido"),
    patente:Yup.string().nullable().test(
        "len",
        "La Patente no es válida",
        (val) => {
          if (val === null || val === undefined) {
            return true;
          }
          return val.length === 0 || (val.length >= 2 && val.length <= 7);
        }
      ).valida_patente_rcg("La Patente no es válida"),   
       
  
      descripcion:Yup.string().test(
      "len",
      "No puede exeder 1000 caracteres..",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 0 && val.length <= 1000);
      }
    ),
      fonoImplicado:Yup.string().test(
      "len",
      "Teléfono debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
      movilImplicado:Yup.string().test(
      "len",
      "Móvil debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
      fonoConductor:Yup.string().test(
      "len",
      "Teléfono debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
      movilConductor:Yup.string().test(
      "len",
      "Móvil debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
      fonoPropietario:Yup.string().test(
      "len",
      "Teléfono debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
      movilPropietario:Yup.string().test(
      "len",
      "Móvil debe tener 10 dígitos.",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length == 10);
      }
    ),
   
    }
    
    )
    
export default validationSchemas;